import {AfterContentInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FontAwesomeService} from '@services/font-awesome.service';
import {TranslateService} from '@ngx-translate/core';
import {OrderCompletionState, selectUser} from '@store/reducers';
import {takeUntil} from 'rxjs/operators';
import {User} from '@models/user.interface';
import {ORDER_LOAD_SUCCESS, OrderLoadSuccess} from '@store/actions';
import {Store} from '@ngrx/store';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-order-complete-card',
  templateUrl: './order-complete-card.component.html',
  styleUrls: ['./order-complete-card.component.scss']
})
export class OrderCompleteCardComponent {
  @Input() orderCompletion: OrderCompletionState;

  constructor(
    public faService: FontAwesomeService,
    public translate: TranslateService,
    public store: Store<any>) { }
}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/order-complete/components/order-complete-card/order-complete-card.component.ts